type Value = string | number | boolean;

export function isEmpty(value: Array<Value> | Value): boolean {
  return Array.isArray(value) ? value.length === 0 : !value;
}
